import {
  DestroyRef,
  Directive,
  Input,
  OnChanges,
  OnInit,
  ViewContainerRef,
  inject,
} from '@angular/core';

import { toggleCssClass } from '@recruitee/common';

import { IconComponent } from '../../../icon/icon.component';
import { setInputs } from '../../button.types';
import { ButtonComponent } from '../../components/button/button.component';

@Directive({
  standalone: true,
  selector: 'rt-button[dropdownOpened], a[rt-button][dropdownOpened]',
})
export class ButtonDropdownIndicatorDirective implements OnChanges, OnInit {
  @Input() public dropdownOpened: boolean = false;
  @Input() public dropdownVisible: boolean = true;
  @Input() public classActive: boolean;

  private vcRef: ViewContainerRef;
  private destroyRef = inject(DestroyRef);

  private buttonStateClassToggles = [
    toggleCssClass('dropdown-indicator', () => this.dropdownVisible),
    toggleCssClass('dropdown-indicator-hidden', () => !this.dropdownVisible),
    toggleCssClass('dropdown-open', () => this.dropdownOpened),
    toggleCssClass('active', () => this.classActive || this.dropdownOpened),
  ];

  constructor(private button: ButtonComponent) {}

  public ngOnChanges(): void {
    this.buttonStateClassToggles.forEach(toggle => toggle.toggleIfCondition());
  }

  public ngOnInit() {
    this.vcRef = this.button.secondarySlot;
    const iconComponentRef = this.vcRef.createComponent(IconComponent);
    setInputs(iconComponentRef, {
      name: 'arrow-drop-down',
      size: 'small',
    });
    this.destroyRef.onDestroy(() => iconComponentRef.destroy());
  }
}
